import { render, staticRenderFns } from "./skuManagement.vue?vue&type=template&id=dd8b656e&scoped=true"
import script from "./skuManagement.vue?vue&type=script&lang=js"
export * from "./skuManagement.vue?vue&type=script&lang=js"
import style0 from "./skuManagement.vue?vue&type=style&index=0&id=dd8b656e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8b656e",
  null
  
)

export default component.exports